<template>
    <svg class="stacked-bar-chart" :width="width" :height="height" :viewBox="'0 0 '+width+' '+height">
        <g :transform="'translate('+ margin.left +','+ margin.top +')'">
            <g class="axis">
                <g ref="yAxis" class="y-axis"></g>
                <g ref="xAxis" class="x-axis" :transform="'translate(0,'+chartHeight+')'"></g>
            </g>
            <g class="area-chart">
                <path :d="area(animatedAreaData)" stroke="#0049B9" fill="#0049B9" fill-opacity="0.35"></path>
                <circle v-for="d in areaData" :cx="x(d[dimensions[0]]) + x.bandwidth()/2" :cy="y(d[metric])" r="3" style="cursor: pointer" v-tooltip fill="transparent" :title="d[metric]+'%'"></circle>
            </g>
            <g class="chart">
                <g v-for="(g,key) in groupedData" :transform="'translate('+x(key)+',0)'">
                    <stacked-chart :data="g" :dimension="dimensions[1]" :metric="metric" :width="x.bandwidth()" :height="chartHeight" :color="color" :y-domain="y.domain()"></stacked-chart>
                </g>
            </g>
        </g>

    </svg>
</template>
<style lang="scss">
    .stacked-bar-chart{
        .axis{
            .x-axis{
                .tick{
                    text{
                        text-anchor: end;
                        transform: rotate(-45deg);
                        font-size: 16px;
                    }
                }
            }
            .y-axis{
                .domain{
                    display: none;
                }
                .tick{
                    text{
                        font-size: 14px;
                        fill: #8F8F8F;
                    }
                    line{
                        stroke: #888888;
                    }
                }
            }
        }
        .area-chart{
            path{
                transition: all ease-out 1s;
            }
        }
        .chart{
            rect{
                transition: all ease-out 1s;
            }
        }

    }
</style>
<script>
    import * as d3 from 'd3';
    import _ from 'lodash';
    import StackedChart from './StackedChart';
    import Tooltip from '../../Directives/Tooltip';

    export default {
        data: function(){
            return {
                margin:{
                    left: 50,
                    top: 10,
                    right: 0,
                    bottom: 110
                },
                animation: 0
            }
        },
        props:{
            areaData: {},
            data: {},
            width: {default: 1050},
            height: {default: 500},
            dimensions: {},
            metric: {},
            color: {},
            yDomain: {}
        },
        components:{
            StackedChart
        },
        directives:{
            Tooltip
        },
        computed:{
            groupedData: function(){
                return _(this.animatedData)
                    .groupBy(this.dimensions[0])
                    .value();
            },
            chartWidth: function(){
                return this.width - this.margin.left - this.margin.right;
            },
            chartHeight: function(){
                return this.height - this.margin.top - this.margin.bottom;
            },
            area: function(){
                return d3.area()
                    .x((d) => { return this.x(d[this.dimensions[0]]) + this.x.bandwidth()/2; })
                    .y1((d) => { return this.y(d[this.metric]); })
                    .y0(this.y(0));
            },
            x: function(){
                return d3.scaleBand()
                    .padding(0.3)
                    .range([0, this.chartWidth])
                    .domain(_(this.groupedData).map((d,key)=>{return key}).value());
            },
            y: function(){
                return d3.scaleLinear()
                    .range([this.chartHeight, 0])
                    .domain(this.yDomain || [0, d3.max(this.data, (d) => {return 1 * d[this.metric]})])
                    .nice();
            },
            axisLeft: function(){
                return d3.axisLeft(this.y)
                    .tickSize(-this.chartWidth)
                    .tickFormat((d)=>{
                        return d + '%';
                    });
            },
            axisBottom: function(){
                return d3.axisBottom(this.x);
            },
            animatedAreaData: function(){
                return _(_.cloneDeep(this.areaData)).forEach(d => {
                        d[this.metric] = d[this.metric] * this.animation;
                    });
            },
            animatedData: function(){
                return _(_.cloneDeep(this.data)).forEach(d => {
                    d[this.metric] = d[this.metric] * this.animation;
                });
            }
        },
        watch:{
            data: function(){
                d3.select(this.$refs.yAxis).call(this.axisLeft);
                d3.select(this.$refs.xAxis).call(this.axisBottom);

                this.animation = 0;
                setTimeout(()=>{
                    this.animation = 1;
                });


            }
        },
    }
</script>


// WEBPACK FOOTER //
// src/js/Components/Charts/StackedBarChart.vue